import {IPortalServices, IRequestError} from "../lt-ng/portal-services";
import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {IFeatureState} from "./feature_state";
import {FeaturesEvents} from "./events/FeaturesEvents";
import Feature from "ol/Feature";
import {GeoJSON} from "ol/format";
import {Geometry} from "ol/geom";
import {
    IPointReport,
    PinReport,
    PointReportRequestAndLayers, ReportKind
} from "./ISharedFeatureState";


export interface IPointQueryFeatureService {
    showGeom(report: PinReport, results: PointReportRequestAndLayers, scienceLayerName: string, pk: number) : ng.IHttpPromise<any>;
    clearGeom();
}

const REQUEST_CANCELLED = 'request-cancelled';

export class PointQueryFeatureService implements IPointQueryFeatureService {
    public static $inject = [
        '$rootScope',
        'landcareMapService',
        'portalServices',
        '$q',
        'featureState'];

    protected cancelRequest: ng.IDeferred<any> = null;

    constructor(protected $rootScope: ng.IRootScopeService,
                protected mapService: IMapService,
                protected portalServices: IPortalServices,
                protected $q: ng.IQService,
                protected featureState: IFeatureState) {

        let refreshQuery = () => {
            this.clearGeom();

            const report = this.featureState.sharedState().activeReport;
            if (!report || report.kind !== ReportKind.pin) return;
            let reportRequest = this.featureState.getPointQueryResultsForCurrentScienceLayer();
            if (!reportRequest) return;


            let scienceLayers = reportRequest.queriedLayers;

            if (scienceLayers.length) {
                let geometryPk: ng.IPromise<[string, number]> = reportRequest.request.request.then((data: IPointReport|IRequestError) => {
                    if ('error' in data) {
                        throw new Error('request failed')
                    }


                    let layers = data.response.layers;

                    if (!layers.length) {
                        throw new Error('No layer enabled');
                    }

                    let names : string[] = [];
                    let pks : number[] = [];
                    layers.forEach((l) => {
                        let rows = l.rows;
                        return rows.forEach((r) => {
                            let columns = r.columns;
                            columns
                                .filter((c) => c.name == 'INTERNAL_GEOMETRY_PK')
                                .forEach((g) => {
                                    names.push(l.name);
                                    pks.push(<number> g.value);
                                });
                        });
                    });

                    if (names.length) {
                        return <[string, number]> [
                            names[0],
                            pks[0]
                        ]
                    }
                });
                geometryPk.then((nameAndPk) => {
                    if (nameAndPk) {
                        let name = nameAndPk[0];
                        let pk = nameAndPk[1];
                        this.showGeom(report, reportRequest, name, pk);
                    }
                });
            }
        };

        this.$rootScope.$on(FeaturesEvents.reportChanged, refreshQuery);

        $rootScope.$on('selectedPin:change', (/*event, info: { oldValue : IPinData, newValue : IPinData}*/) => {
            refreshQuery();
        });

        $rootScope.$on('scienceLayer',
            (/*event, info: {oldValue: Item, newValue: Item}*/) => {
                refreshQuery();
            });

    }

    private currentFeature: Feature<Geometry> = null;
    private currentScienceLayerName: string;
    private currentX: number;
    private currentY: number;
    private currentGeometryPk: number = null;
    private currentGeometryCanceler: ng.IDeferred<any>;

    protected getSource() {
        return this.mapService.featuresLayer.getSource();
    }

    clearGeom() {
        if (this.cancelRequest) {
            console.log("Cancelling point query request.");
            this.cancelRequest.resolve(REQUEST_CANCELLED);
            delete this.cancelRequest;
        }

        if (this.currentGeometryCanceler) {
            console.log('Canceling geometry request');
            this.currentGeometryCanceler.resolve(REQUEST_CANCELLED);
            delete this.currentGeometryCanceler;
        }

        if (this.currentFeature) {
            console.log('Removing pin geometry');
            this.getSource().clear();
            // try {
            //     this.getSource().removeFeature(this.currentFeature);
            // } catch (e) {
            //     console.log("Error removing feature");
            //     console.log(e);
            // }

            this.currentFeature = null;
            this.clear();
        }
    }

    private clear() {
        delete this.currentGeometryPk;
        delete  this.currentScienceLayerName;
        delete this.currentX;
        delete this.currentY;
    }

    protected isActiveReportAndRequest(report: PinReport, results: PointReportRequestAndLayers) : boolean {
        return report == this.featureState.sharedState().activeReport
            && results == this.featureState.getPointQueryResultsForCurrentScienceLayer();
    }

    showGeom(report: PinReport, results: PointReportRequestAndLayers, scienceLayerName: string, pk: number) : ng.IHttpPromise<any> {
        if (!pk) return;
        if (!this.isActiveReportAndRequest(report, results)) return;

        this.currentScienceLayerName = scienceLayerName;
        this.currentGeometryPk = pk;
        this.currentGeometryCanceler = this.$q.defer();

        let geometryQuery : ng.IHttpPromise<any> = this.portalServices
            .geometryPointQuery(scienceLayerName, pk, {
                cache: true,
                timeout: this.currentGeometryCanceler.promise
            });

        geometryQuery.then((response) => {
            if (!response) {
                console.log("No geometry query");
                return;
            }
            if (!this.isActiveReportAndRequest(report, results)) return;

            let fmt = new GeoJSON();
            let newFeature = fmt.readFeature(response.data.response);
            this.getSource().addFeature(newFeature);
            this.currentFeature = newFeature;
        }, (error) => {
            console.warn(error);
            this.clear();
        });

        return geometryQuery;
    }
}
